e<template>
<div>
    <div v-if="role != 'employee'" class="header">
        <!-- <div class="header-title">
            Work orders
            <span v-if="workorders.length > 0"
                  class="text-muted">
                    ({{ workorders.length }})
                </span>
        </div>
        <div class="header-description text-muted">
            Use work orders to notify your crew of things that need to be done.
        </div> -->
        <div class="alert alert-success"
             v-if="createdWorkOrder">
            Awesome, your work order was created and we have sent notifications to the crew.
        </div>
        <button key="button"
                v-if="!showForm"
                class="btn btn-primary"
                :class="{ disabled: showForm }"
                @click="showForm = true">
            Create new work order
        </button>
        <transition name="fade">
            <div key="key1"
                 v-if="showForm">
                <new-work-order :project="project" :workorders="workorders"></new-work-order>
            </div>
        </transition>
    </div>
    <div v-if="loading"
         class="card card-default">
        <div class="card-header">
            <span class="loading-text">Loading...</span>
            <span class="loader float-right"></span>
        </div>
    </div>
    <div v-else-if="error"
         class="card card-default">
        <div class="card-header">
            <div class="alert alert-primary"
                 role="alert">
                <div><strong>Well, this is embarrassing.</strong> Something went wrong.</div>
                <div>Please try refreshing the page, or otherwise <a href="mailto:support@sitecommandapp.com?subject=Help!">get in touch</a> and we'll be happy to help!
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <caught-up-message v-if="role == 'employee' && !loading && workorders.length == 0" :object="'work orders'"></caught-up-message>
        <work-order v-for="workorder in workorders" :user="user" :key="workorder.id" :workorder="workorder" :project="project"></work-order>
    </div>
</div>
</template>
<script>
export default
{
    props: ['role', 'user', 'project'],

    created: function()
    {
        this.getWorkOrders();
        this.registerEvents();
    },

    mounted: function() {

    },

    data: function()
    {
        return {
            workorders: [],
            loading: true,
            error: false,
            showForm: false,
            createdWorkOrder: false
        };
    },

    computed:
    {},

    watch:
    {
        project: function(newProject, oldProject)
        {
            if (!oldProject || (newProject.id != oldProject.id)) {
                this.refresh();
            }
        }
    },

    methods:
    {
        registerEvents: function() {
            var vm = this;
            Bus.$on('new-work-order-created', function (response) {
                vm.newWorkOrderCreated(response);
                return true;
            });
            Bus.$on('new-work-order-canceled', function (response) {
                vm.showForm = false;
                return true;
            });
            Bus.$on('work-order-updated', function (response) {
                vm.workOrderUpdated(response);
                return true;
            });
            Bus.$on('work-orders-updated', function () {
                vm.getWorkOrders();
                return true;
            });
            Bus.$on('work-order-deleted', function(response) {
                vm.workOrderDeleted(response.id);
                return true;
            });
        },

        workOrderDeleted: function(deletedWorkOrderId) {
            for (var index in this.workorders) {
                var workorder = this.workorders[index];
                if (workorder.id == deletedWorkOrderId) {
                    // Use Vue.set to get reactivity when changing the contents of an array
                    Vue.delete(this.workorders, this.workorders.indexOf(workorder));
                    break;
                }
            }
        },

        workOrderUpdated: function(updatedWorkOrder) {
            for (var index in this.workorders) {
                var workorder = this.workorders[index];
                if (workorder.id == updatedWorkOrder.id) {
                    // Use Vue.set to get reactivity when changing the contents of an array
                    Vue.set(this.workorders, this.workorders.indexOf(workorder), updatedWorkOrder);
                    break;
                }
            }
        },

        newWorkOrderCreated: function(workorder) {
            this.createdWorkOrder = true;
            this.showForm = false;
            this.workorders.unshift(workorder);
        },

        /**
         * Get the available member roles.
         */
        getWorkOrders: function()
        {
            if (!this.project) {
                return;
            }

            this.workorders = [];
            axios.get(`/api/workorders/${this.project.id}`)
                .then(response =>
                {   
                    this.loading = false;
                    this.error = false;
                    this.workorders = response.data;

                    if (this.workorders.length == 0) {
                        this.showForm = true;
                    }
                })
                .catch(error =>
                {
                    this.loading = false;
                    this.error = true;
                });
        },

        refresh: function()
        {
            this.loading = true;
            this.getWorkOrders();
        },
    }
}

</script>
